import React, { useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';

import Bloque from '../../commons/Bloque';
import { useFormularioContext } from '../../commons/Formulario';
import Loading from '../../commons/Loading';
import Boton from '../../commons/Boton';
import { addNewLine, formatoFecha } from '../../commons/Utilitarios';
import GroupText from '../../commons/GroupText';

import MaterialCommunityIcons from '../../commons/Icons/MaterialCommunityIcons';
import MaintenanceItem from './MaintenanceItem';

const RequestStart = () => {
  const { selected, processing, dispatch, openModalTask } =
    useFormularioContext();

  if (!openModalTask) {
    return null;
  }

  return (
    <>
      {processing && <Loading tipo={'request'} />}
      <Bloque
        titulo={`Solicitud ${selected?.cs}`}
        className={`maintenance ${openModalTask ? 'active' : ''}`}
        hideArrowButton
        onActions={() => (
          <Boton
            className="op-cerrar"
            icon={() => <CloseIcon />}
            onClick={() => dispatch({ type: 'CLOSE_TASK' })}
          >
            Cerrar
          </Boton>
        )}
      >
        <div className="maintenance-content">
          <div className="request-content">
            <GroupText
              label={selected.ii?.dn}
              text={'Cliente'}
              icon={
                <MaterialCommunityIcons
                  name={'account-tie'}
                  size={20}
                  color={'#102a68'}
                />
              }
            />
            <GroupText
              label={selected.ii?.di}
              text={'Dirección'}
              icon={
                <MaterialCommunityIcons
                  name={'home-map-marker'}
                  size={20}
                  color={'#102a68'}
                />
              }
            />
            <GroupText
              label={addNewLine(selected.ds)}
              text={'Problema'}
              icon={
                <MaterialCommunityIcons
                  name={'cog-transfer-outline'}
                  size={20}
                  color={'#102a68'}
                />
              }
            />
            <GroupText
              label={formatoFecha(selected.fv)}
              text={'Vísita técnica'}
              icon={
                <MaterialCommunityIcons
                  name={'calendar-cursor'}
                  size={20}
                  color={'orange'}
                />
              }
            />
          </div>
          <MaintenanceItem />
        </div>
      </Bloque>
    </>
  );
};

export default RequestStart;
